import { render } from "./AnagraficaClienti.vue?vue&type=template&id=e7018c0a&scoped=true"
import script from "./AnagraficaClienti.vue?vue&type=script&lang=js"
export * from "./AnagraficaClienti.vue?vue&type=script&lang=js"

import "./AnagraficaClienti.vue?vue&type=style&index=0&id=e7018c0a&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7018c0a"]])

export default __exports__